import { FC } from 'react';
import { Button, Icon } from 'learning-panel-components';
import { translate } from 'translations';
import styles from './downloadHubButton.module.scss';

const DownloadHubButton: FC<DownloadHubButtonProps> = (props: DownloadHubButtonProps) => {
    const { onClick, status, isOpen } = props;

    const getStartIcon = () => {
        switch (status) {
            case 'inProgress':
                return undefined;
            case 'newSuccess':
                return <Icon name="whiteCheck" />;
            default:
                return <Icon name="downloadHub" />;
        }
    };

    return (
        <div className={styles['download-hub-button-wrapper']}>
            {status === 'newSuccess' && <div className={styles['new-indicate']} />}
            <Button
                type={isOpen ? 'learningPanelAdminPinkActive' : 'learningPanelAdminPink'}
                text={translate('DownloadHub')}
                extraLoader={status === 'inProgress'}
                lowerCase
                startIcon={getStartIcon()}
                onClick={onClick}
            />
        </div>
    );
};

export default DownloadHubButton;

export enum DownloadHubButtonStatus {
    inProgress = 'inProgress',
    newSuccess = 'newSuccess'
}

interface DownloadHubButtonProps {
    onClick: Function;
    status?: keyof typeof DownloadHubButtonStatus;
    isOpen: boolean;
}
